<template>
  <section class="list-group">
    <div
      v-for="(section, index) in popularSection"
      :key="`popular_${index}`"
      class="list-cont"
    >
      <strong class="tit-subject" tabindex="0">{{
        getSectionTitle(section)
      }}</strong>
      <div class="popular-list multi">
        <SearchPopularCellList :cell-list="getCellList(section)" />
      </div>
    </div>
  </section>
</template>

<script>
  import SearchPopularCellList from '@/components/search/view/SearchPopularCellList'
  import _ from 'lodash'

  export default {
    name: 'SearchPopularSectionList',
    components: {
      SearchPopularCellList,
    },
    props: {
      popularSection: {
        type: Array,
        default: null,
      },
    },
    data() {
      return {
        popularSectionList: [],
      }
    },
    created() {
      this.popularSectionList = { ...this.popularSection }
    },
    methods: {
      getSectionTitle(section) {
        return _.get(section, `title_list.0.text`, '')
      },
      getCellList(section) {
        return _.get(section, `celllist`, [])
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tit-subject {
    padding: 0 100px;
  }
  .multi {
    width: auto;
  }
</style>
